module.exports = __webpack_public_path__ + "static/img/iso1.879a7dc1.png";